import {CarouselV2ProductDetailsResponse} from '../../src/contentful/recipeCarouselV2/utils/mapRecipeCarouselV2';
import {fetchFromWebsiteApi} from './fetchData';
import {ApimClientConfiguration, WebsiteApiClient} from './WebsiteApiClient';

export const fetchProductWeekDetails = async (sku: string, week: string): Promise<CarouselV2ProductDetailsResponse> => {
  const config = new ApimClientConfiguration();
  config.setApiKey(process.env.GATSBY_WEBSITE_API_KEY as string, '', '');
  const client = new WebsiteApiClient(config, process.env.GATSBY_WEBSITE_API_URL, fetchFromWebsiteApi);

  return client.productsByskuweekDetails(sku, week);
};
